import { API, settings } from '@/api';
import axios from 'axios';
import router from '@/router';

const getUser = (State) => {
  if (State.currentUser !== null) {
    return State.currentUser;
  } else if (typeof window.sessionStorage.getItem('currentUser') === 'string') {
    State.currentUser = JSON.parse(window.sessionStorage.getItem('currentUser') || 'null');
    return State.currentUser;
  } else {
    return null;
  }
};

const state = {
  currentUser: null,
};
const getters = {
  getUser,
  getUsername: (State) => {
    const user = getUser(State);
    if (user === null) {
      return '';
    }
    return user.name;
  },
};
const actions = {
  setUser({ commit, State }, user) {
    commit('setUser', user);
  },
  logout({ commit, State }) {
    const user_pool_domain = settings.auth.user_pool_domain;
    const clientId = settings.auth.clientId;
    const retlogout = settings.auth.retlogout;
    const logoutPath = `https://${user_pool_domain}/logout?client_id=${clientId}&logout_uri=${retlogout}`;
    commit('clearAdmin');
    commit('clearCondo');
    commit('clearUser');
    window.localStorage.removeItem('authorization');
    // @ts-ignore
    const currentName = router.history.current.name;
    const loginComponentNames = ['home', 'login', 'logout'];
    if (loginComponentNames.includes(currentName)) {
      return;
    }
    window.location.href = logoutPath;
  },
};
const mutations = {
  setUser: (State, currentUser) => {
      State.currentUser = currentUser;
      window.sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
  },
  clearUser: (State) => {
    State.currentUser = null;
    window.sessionStorage.removeItem('currentUser');
  },
};

export default {
  actions,
  mutations,
  getters,
  state,
};
